module.exports = __webpack_public_path__ + "static/media/email01.79b50514.png";